module.exports = __webpack_public_path__ + "img/vertical_3_5_8017.91ff7601.png";